import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { SimpleResponse } from '../models/genericResponse.model';
import { EngageSCResponse, EngageSC, EngageSCContractResponse, EngageSCContract, EngageSCContractSetupResponse, EngageSCContractSaveObj } from '../models/repSettings.model';
import { delayedRetryHttp } from './shared/delayedRetry';
import { UtilityService } from './shared/utility.service';

@Injectable({
  providedIn: 'root'
})
export class RepSettingService {
  private baseUrl: string;
  private api: string = "api/EngageSC";

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
    this.baseUrl = _baseUrl + this.api;
  }

  async getRepSettingList(encryptedUser: string, clpCompanyId: number, cLPUserId: number): Promise<EngageSCResponse | void> {
    const a = await this.httpClient
      .get<EngageSCResponse>(`${this.baseUrl}/EngageSC_GetList/${clpCompanyId}?cLPUserId=${cLPUserId}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "clpCompanyId - " + clpCompanyId + "," + "cLPUserId - " + cLPUserId, encryptedUser, "RepSettingService", "getRepSettingList"); });
    return a;
  }

  async updateRepSettings(encryptedUser: string, EngageSC: EngageSC): Promise<EngageSCResponse | void> {
    const a = await this.httpClient.post<EngageSCResponse>(`${this.baseUrl}/EngageSC_Update`, EngageSC, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + encryptedUser
      })
    }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, EngageSC, "r - " + encryptedUser, encryptedUser, "RepSettingService", "updateRepSettings") });
    return a;
  }

  async getContractList(encryptedUser: string, engageSCID: number, cLPCompanyID: number, teamCode: number): Promise<EngageSCContractResponse | void> {
    const a = await this.httpClient
      .get<EngageSCContractResponse>(`${this.baseUrl}/EngageSCContract_GetList?engageSCID=${engageSCID}&cLPCompanyID=${cLPCompanyID}&teamCode=${teamCode}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "engageSCID - " + engageSCID + "," + "cLPCompanyID - " + cLPCompanyID + "," + "teamCode - " + teamCode, encryptedUser, "RepSettingService", "getContractList"); });
    return a;
  }


  async sendSOContractServicesEmail(encryptedUser: string, fromClpUserId: number, engageScContractId: number): Promise<SimpleResponse | void> {
    const a = await this.httpClient
      .get<SimpleResponse>(`${this.baseUrl}/SendSOContractServicesEmail?fromClpUserId=${fromClpUserId}&engageScContractId=${engageScContractId}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "fromClpUserId - " + fromClpUserId + "," + "engageScContractId - " + engageScContractId, encryptedUser, "RepSettingService", "sendSOContractServicesEmail"); });
    return a;
  }
  async setupSOSCContract(encryptedUser: string, engageScId: number, engageScContractId: number , selectedCompanyId: number, teamCode: number): Promise<EngageSCContractSetupResponse | void> {
    const a = await this.httpClient
      .get<EngageSCContractSetupResponse>(`${this.baseUrl}/Setup_SOSCContract/${engageScId}/${engageScContractId}/${selectedCompanyId}/${teamCode}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "engageScId - " + engageScId + "," + "engageScContractId - " + engageScContractId, encryptedUser, "RepSettingService", "setupSOSCContract"); });
    return a;
  }

  async deleteContractList(encryptedUser: string, engageSCContractID: number): Promise<SimpleResponse | void> {
    const http$ = await this.httpClient
      .get<SimpleResponse>(`${this.baseUrl}/EngageSCContract_Delete?engageSCContractID=${engageSCContractID}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "engageSCContractID - " + engageSCContractID, encryptedUser, "RepSettingService", "deleteContractList") });
    return http$;
  }

    async engageSCContract_Save(encryptedUser: string, clpUserId: number, saveAsId: number, isSaveAs: boolean, engageSCContract: EngageSCContractSaveObj): Promise<SimpleResponse | void> {
    const a = await this.httpClient.post<SimpleResponse>(`${this.baseUrl}/EngageSCContract_Save/${clpUserId}/${saveAsId}/${isSaveAs}`, engageSCContract, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + encryptedUser
      })
    }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, engageSCContract, "r - " + encryptedUser + "," + "clpUserId - " + clpUserId + "," + "saveAsId - " + saveAsId + "," + "isSaveAs - " + isSaveAs, encryptedUser, "RepSettingService", "updateContractList") });
    return a;

  }

  async getHTML(encryptedUser: string, engageScId: number = 0, engageScContractId: number = 0): Promise<SimpleResponse | void> {
    const a = await this.httpClient.get<SimpleResponse>(`${this.baseUrl}/GetHTML?engageScId=${engageScId}&engageScContractId=${engageScContractId}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + encryptedUser
      })
    }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "engageScId - " + engageScId + "," + "engageScContractId - " + engageScContractId, encryptedUser, "RepSettingService", "getHTML") });
    return a;

  }
  async downloadContractPdf(encryptedUser: string, engageSCContractID: number, companyName: string): Promise<any | void> {
    const a = await this.httpClient
      .get<any>(`${this.baseUrl}/GenratePDF/${engageSCContractID}/${companyName}`, {
        'responseType': 'arraybuffer' as 'json',
        headers: new HttpHeaders({
          'responseType': 'arraybuffer',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "engageSCContractID - " + engageSCContractID+ "," + "companyName - " + companyName , encryptedUser, "RepSettingService", "downloadContractPdf"); });

    return a;
  }

  }

